export const FERRET_ID = 'ferretWL';
